var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsInt, IsOptional, IsUUID, Min, ValidateNested, } from 'class-validator';
import { AgreementDataDto } from './agreement-data.dto.js';
import { GkvInsuranceDataDto } from './gkv-insurance-data.dto.js';
import { PrescriptionDataDto } from './prescription-data.dto.js';
import { CreateTreatmentUnitInputDto } from './treatment-unit.dto.js';
export class CreateTreatmentPlanDto {
    patientId;
    payerDomainId;
    caseTypeId;
    authorizedUnitCount;
    validFrom;
    validUntil;
    prescriptionData;
    agreementData;
    /**
     * The eGK snapshot (#1503). Sent by the GKV Verordnungsformular and ignored by
     * every other payer — the server builds the satellite for a GKV plan whether
     * or not this block arrives, because the satellite is required and its fields
     * are not. Sending it for a non-GKV plan is refused rather than dropped.
     */
    gkvInsuranceData;
    treatmentUnits;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CreateTreatmentPlanDto.prototype, "patientId", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], CreateTreatmentPlanDto.prototype, "payerDomainId", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateTreatmentPlanDto.prototype, "caseTypeId", void 0);
__decorate([
    Expose(),
    IsInt(),
    Min(1),
    __metadata("design:type", Number)
], CreateTreatmentPlanDto.prototype, "authorizedUnitCount", void 0);
__decorate([
    Expose(),
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateTreatmentPlanDto.prototype, "validFrom", void 0);
__decorate([
    Expose(),
    IsDateString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateTreatmentPlanDto.prototype, "validUntil", void 0);
__decorate([
    Expose(),
    ValidateNested(),
    Type(() => PrescriptionDataDto),
    IsOptional(),
    __metadata("design:type", Object)
], CreateTreatmentPlanDto.prototype, "prescriptionData", void 0);
__decorate([
    Expose(),
    ValidateNested(),
    Type(() => AgreementDataDto),
    __metadata("design:type", AgreementDataDto)
], CreateTreatmentPlanDto.prototype, "agreementData", void 0);
__decorate([
    Expose(),
    ValidateNested(),
    Type(() => GkvInsuranceDataDto),
    IsOptional(),
    __metadata("design:type", Object)
], CreateTreatmentPlanDto.prototype, "gkvInsuranceData", void 0);
__decorate([
    Expose(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => CreateTreatmentUnitInputDto),
    __metadata("design:type", Array)
], CreateTreatmentPlanDto.prototype, "treatmentUnits", void 0);
//# sourceMappingURL=create-treatment-plan.dto.js.map